<div id="info-box"><fa class="me-2" :icon="['fas', 'info-circle']"></fa>{{msg}}</div>